<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page brands-mobile-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
  *ngIf="!contentReady"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i class="fa-solid fa-tags"></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'Brand Management' | transloco }}
            </span>

            <h2>
              {{ 'Brand Management' | transloco }}
            </h2>

            <p>
              {{ 'allbrands.totalBrands' | transloco }}:
              <strong>
                {{ stockTotal || 0 }}
              </strong>
            </p>
          </div>

        </div>

        <div class="bbm-hero-counter">
          <strong>
            {{ stockTotal || 0 }}
          </strong>

          <span>
            {{ 'allbrands.totalBrands' | transloco }}
          </span>
        </div>

      </div>

      <div class="bbm-actions-grid bbm-hero-actions noPrint">
        <button
          type="button"
          routerLink="/createbrand"
          class="bbm-action-btn bbm-action-primary bbm-action-wide"
        >
          <i class="fa-solid fa-plus"></i>

          <span>
            {{ 'createbrand' | transloco }}
          </span>
        </button>
      </div>

    </section>

    <!-- BRANDS LIST -->
    <section
      class="bbm-ticket-list"
      *ngIf="allData.length > 0"
    >
      <article
        class="bbm-ticket"
        *ngFor="let element of allData"
      >

        <!-- BRAND TOP -->
        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-brand-logo">
              <img
                [src]="fixurl(element.brand_logo)"
                [alt]="element.brandname_en || 'brand logo'"
              >
            </div>

            <div class="bbm-brand-copy">
              <span class="bbm-eyebrow">
                {{ 'Brand Management' | transloco }}
              </span>

              <h3>
                {{ element.brandname_en || '—' }}
              </h3>

              <p dir="rtl">
                {{ element.brandname_ar || '—' }}
              </p>
            </div>

          </div>

        </div>

        <!-- DESCRIPTIONS -->
        <div class="bbm-description-grid">

          <!-- EN DESCRIPTION -->
          <div class="bbm-description-block">
            <span>
              {{ 'brand_description_en' | transloco }}
            </span>

            <p>
              {{
                element.showMoreEn
                  ? (element.brand_description_en || '—')
                  : (
                      (element.brand_description_en || '—')
                      | slice:0:90
                    )
              }}

              <span
                *ngIf="
                  (element.brand_description_en || '').length > 90 &&
                  !element.showMoreEn
                "
              >
                ...
              </span>
            </p>

            <button
              *ngIf="
                (element.brand_description_en || '').length > 90
              "
              type="button"
              class="bbm-description-toggle"
              (click)="toggleDescription(element, 'en')"
            >
              {{
                element.showMoreEn
                  ? ('allbrands.showLess' | transloco)
                  : ('allbrands.showMore' | transloco)
              }}
            </button>
          </div>

          <!-- AR DESCRIPTION -->
          <div
            class="bbm-description-block"
            dir="rtl"
          >
            <span>
              {{ 'brand_description_ar' | transloco }}
            </span>

            <p>
              {{
                element.showMoreAr
                  ? (element.brand_description_ar || '—')
                  : (
                      (element.brand_description_ar || '—')
                      | slice:0:90
                    )
              }}

              <span
                *ngIf="
                  (element.brand_description_ar || '').length > 90 &&
                  !element.showMoreAr
                "
              >
                ...
              </span>
            </p>

            <button
              *ngIf="
                (element.brand_description_ar || '').length > 90
              "
              type="button"
              class="bbm-description-toggle"
              (click)="toggleDescription(element, 'ar')"
            >
              {{
                element.showMoreAr
                  ? ('allbrands.showLess' | transloco)
                  : ('allbrands.showMore' | transloco)
              }}
            </button>
          </div>

        </div>

        <!-- ACTIONS -->
        <div class="bbm-actions-grid bbm-actions-three bbm-ticket-section">

          <button
            type="button"
            class="bbm-action-btn bbm-action-primary"
            (click)="openAddImage(element.id)"
          >
            <i class="fa-regular fa-image"></i>

            <span>
              {{ 'AddImage' | transloco }}
            </span>
          </button>

          <button
            type="button"
            class="bbm-action-btn bbm-action-warning"
            (click)="edit(element)"
          >
            <i class="fa-regular fa-pen-to-square"></i>

            <span>
              {{ 'Edit' | transloco }}
            </span>
          </button>

          <button
            type="button"
            class="bbm-action-btn bbm-action-danger bbm-action-wide"
            (click)="deleteitem(element.id)"
          >
            <i class="fa-regular fa-trash-can"></i>

            <span>
              {{ 'Delete' | transloco }}
            </span>
          </button>

        </div>

      </article>
    </section>

    <!-- LOADING MORE -->
    <div
      class="bbm-loader"
      *ngIf="loadingMore"
    >
      <span
        class="bbm-loader-spinner"
        aria-hidden="true"
      ></span>

      <span>
        {{ 'allbrands.loadingMore' | transloco }}
      </span>
    </div>

    <!-- END STATE -->
    <div
      class="bbm-end-state"
      *ngIf="!hasMoreData && allData.length > 0"
    >
      {{ 'allbrands.noMoreBrands' | transloco }}
    </div>

    <!-- NO DATA -->
    <div
      class="bbm-empty-state"
      *ngIf="noData"
    >
      <app-nodata></app-nodata>
    </div>

  </div>
</div>

<!-- ADD IMAGE MODAL -->
<div
  *ngIf="addImage"
  class="bbm-modal-backdrop noPrint"
  (click)="close()"
>
  <section
    class="bbm-modal-card"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()"
  >

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">

      <div class="bbm-main-info">

        <div class="bbm-avatar">
          <i class="fa-regular fa-image"></i>
        </div>

        <div>
          <span class="bbm-eyebrow">
            {{ 'Brand Management' | transloco }}
          </span>

          <h3>
            {{ 'allbrands.uploadBrandLogo' | transloco }}
          </h3>
        </div>

      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

    </div>

    <div class="bbm-modal-list">

      <div
        class="bbm-upload-zone"
        role="button"
        tabindex="0"
        (click)="fileInput.click()"
        (keydown.enter)="fileInput.click()"
      >
        <input
          #fileInput
          type="file"
          hidden
          accept="image/*"
          (change)="onImageSelected($event)"
        >

        <!-- EMPTY UPLOAD STATE -->
        <div
          *ngIf="!imagePreview"
          class="bbm-upload-placeholder"
        >
          <span class="bbm-upload-icon">
            <i class="fa-solid fa-cloud-arrow-up"></i>
          </span>

          <strong>
            {{ 'allbrands.uploadBrandLogo' | transloco }}
          </strong>

          <small>
            {{ 'allbrands.imageRules' | transloco }}
          </small>
        </div>

        <!-- IMAGE PREVIEW -->
        <div
          *ngIf="imagePreview"
          class="bbm-image-preview"
        >
          <img
            [src]="imagePreview"
            [alt]="'allbrands.uploadBrandLogo' | transloco"
          >

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-primary
              bbm-action-compact
              bbm-image-change-btn
            "
            (click)="
              fileInput.click();
              $event.stopPropagation()
            "
          >
            <i class="fa-regular fa-image"></i>

            <span>
              {{ 'allbrands.changeImage' | transloco }}
            </span>
          </button>
        </div>

      </div>

    </div>

    <div class="bbm-form-actions">

      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="submitImage()"
        [disabled]="!selectedFile"
      >
        <i class="fa-solid fa-check"></i>

        <span>
          {{ 'Submit' | transloco }}
        </span>
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>

        <span>
          {{ 'close' | transloco }}
        </span>
      </button>

    </div>

  </section>
</div>
